import * as Constants from '../../utils/constants';

export const updateData = () => ({
  type: Constants.UPDATE_DATA
});

export const loadData = (data: any) => ({
  type: Constants.LOAD_DATA,
  payload: data
});

export const watchedLoadsRequest = (payload: any) => ({
  type: Constants.WATCHEDLOAD_DATA_REQUEST,
  payload
});

export const watchLoadsResponse = (payload: any) => ({
  type: Constants.WATCHEDLOAD_DATA_SUCCESS,
  payload
});

export const addWatchLoad = (payload: any) => ({
  type: Constants.ADD_WATCH_LOAD,
  payload
});

export const addWatchLoadSuccess = (payload: any) => ({
  type: Constants.ADD_WATCH_LOAD_SUCCESS,
  payload
});

export const removeWatchLoad = (payload: any) => ({
  type: Constants.REMOVE_WATCH_LOAD,
  payload
});

export const removeWatchLoadSuccess = (payload: any) => ({
  type: Constants.REMOVE_WATCH_LOAD_SUCCESS,
  payload
});

export const setWatchedLoadFilter = (payload: any) => ({
  type: Constants.WATCHED_LOAD_FILTER,
  payload
});

export const setRecommendedLoadFilter = (payload: any) => ({
  type: Constants.RECOMMENDED_LOAD_FILTER,
  payload
});

export const showApiResponseError = (payload: any) => ({
  type: Constants.SHOW_API_RESPONSE_ERROR,
  payload
});

export const clearApiResponseError = () => ({
  type: Constants.CLEAR_API_RESPONSE_ERROR
});

export const recommendedLoadsRequest = (payload: any) => ({
  type: Constants.RECOMMENDED_LOADS_REQUEST,
  payload
});

export const recommendedLoadsSuccess = (payload: any) => ({
  type: Constants.RECOMMENDED_LOADS_SUCCESS,
  payload
});

export const toprecommendedLoadsSuccess = (payload: any) => ({
  type: Constants.TOP_RECOMMENDED_LOADS_SUCCESS,
  payload
});

export const similarLoadsRequest = (payload: any,callback?: any) => ({
  type: Constants.SIMILAR_LOADS_REQUEST,
  payload: {
    data: payload,
    callback
  }
});

export const fetchAvailableLoads = (payload: any, callback?: Function) => ({
  type: Constants.AVAILABLE_LOADS_REQUEST,
  payload: {
    data: payload,
    callback
  }
});

export const similarLoadsSuccess = (payload: any) => ({
  type: Constants.SIMILAR_LOADS_SUCCESS,
  payload
});

export const fetchAvailableLoadsSuccess = (payload: any) => ({
  type: Constants.AVAILABLE_LOADS_SUCCESS,
  payload
});
export const removeRecommendedResults = (payload: any) => ({
  type: Constants.REMOVE_RECOMMENDEDRESULTS,
  payload
});

export const showMemberApiError = (payload: any) => ({
  type: Constants.SHOW_MEMBER_API_ERROR,
  payload
});

export const setRecommendedApiError = (payload: any) => ({
  type: Constants.SET_RECOMMENDED_API_ERROR,
  payload
});
